import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 12h14v4","key":"svg-0"}]]

const IconMathNot = createReactComponent('outline', 'math-not', 'MathNot', __iconNode);

export default IconMathNot;